export function basename(path) {
  return path.split('/').pop();
}

export function parentOf(path) {
  const segments = path.split('/');

  segments.pop();

  return segments.join('/');
}

export function ancestors(path) {
  const segments = path.split('/');

  segments.pop();

  return segments.map((_segment, index) => segments.slice(0, index + 1).join('/'));
}

export function inside(path, folder) {
  return path === folder || path.startsWith(`${folder}/`);
}

export function moved(path, from, to) {
  if (!inside(path, from)) return path;

  return `${to}${path.slice(from.length)}`;
}

export function directories(filePaths, emptyFolders) {
  const found = new Set();

  for (const folder of emptyFolders) {
    found.add(folder);

    for (const ancestor of ancestors(folder)) found.add(ancestor);
  }

  for (const path of filePaths) {
    for (const ancestor of ancestors(path)) found.add(ancestor);
  }

  return found;
}
